module.exports = __webpack_public_path__ + "img/10-shuttle-run.cebea5ae.png";